import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class RunCreateExtractsOnDatasourcesRequest extends Request<IMultipleIdsParams, IResult> {
  constructor(ids: string[]) {
    super('runCreateExtractsOnDatasources', {
      ids: ids
    });
  }
}
